import React from 'react';

type StarIconProps = {
  fill?: boolean;
};

const StarIcon: React.FC<StarIconProps> = ({ fill = false }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="33"
    viewBox="0 0 37 35"
    fill={fill ? '#88c827' : 'none'}
  >
    <path
      d="M18.7576 27.7004L18.5 27.5456L18.2424 27.7004L7.82376 33.9618L10.5878 22.1641L10.6569 21.8692L10.4276 21.6714L1.22703 13.735L13.3436 12.7114L13.6436 12.686L13.7616 12.409L18.5 1.27667L23.2384 12.409L23.3564 12.686L23.6564 12.7114L35.773 13.735L26.5724 21.6714L26.3431 21.8692L26.4122 22.1641L29.1762 33.9618L18.7576 27.7004Z"
      stroke={fill ? '#88c827' : 'black'}
    />
  </svg>
);

export default StarIcon;
